export default "__VITE_ASSET__BzssHfPa__"